var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.175 44.9625C39.8113 42.5287 36.8 40.0125 36.8 36.0938C36.8 31.5975 40.9662 28.4625 47.9375 28.4625C53.795 28.4625 56.7238 30.69 57.7963 34.2375C58.2913 35.8875 59.6525 37.125 61.385 37.125H62.6225C65.345 37.125 67.2837 34.4438 66.335 31.8862C64.6025 27.0188 60.56 22.9763 54.125 21.4088V18.5625C54.125 15.1388 51.3612 12.375 47.9375 12.375C44.5138 12.375 41.75 15.1388 41.75 18.5625V21.285C33.7475 23.0175 27.3125 28.215 27.3125 36.1763C27.3125 45.705 35.1912 50.4487 46.7 53.2125C57.0125 55.6875 59.075 59.3175 59.075 63.1538C59.075 66 57.0538 70.5375 47.9375 70.5375C41.1313 70.5375 37.625 68.1037 36.2638 64.6388C35.645 63.03 34.2425 61.875 32.5512 61.875H31.3962C28.6325 61.875 26.6937 64.68 27.725 67.2375C30.0762 72.9712 35.5625 76.3537 41.75 77.6738V80.4375C41.75 83.8613 44.5138 86.625 47.9375 86.625C51.3612 86.625 54.125 83.8613 54.125 80.4375V77.7562C62.1688 76.23 68.5625 71.5688 68.5625 63.1125C68.5625 51.3975 58.5388 47.3962 49.175 44.9625Z",
    fill: "#C8283B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.b0a2058bdad6325cb9bd5cd925818298.svg";
export { ForwardRef as ReactComponent };